import { transform, every } from 'lodash'

interface transformValueInterface {
  (value: any): any
}

const transformValue: transformValueInterface = (value) => {
  if (value === null) {
    return null
  }

  if (value === '') {
    return null
  }

  if (Array.isArray(value)) {
    return value
      .filter((v) => v !== '' && v !== null)
      .filter(
        (v) =>
          typeof v !== 'object' ||
          !every(Object.values(v), (vv) => vv === null || vv === '')
      )
      .map((v) => transformValue(v))
  }

  if (typeof value === 'object') {
    return sanitizeEmptyStringValues(value)
  }

  return value
}

export const sanitizeEmptyStringValues = (subject: object) =>
  transform(subject, (result: { [field: string]: any }, value, key) => {
    result[key] = transformValue(value)
  })
